import axios from 'axios';
import { API_BASE_URL } from './utils';

const partnerApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('partner_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

partnerApi.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('partner_token');
      localStorage.removeItem('partner_data');
      if (window.location.pathname.startsWith('/partner')) {
        window.location.href = '/partner/login';
      }
    }
    return Promise.reject(error);
  }
);

const BASE = '/partner/portal';

export const partnerPortalAPI = {
  login: (data) => partnerApi.post(`${BASE}/auth/login`, data),
  me: () => partnerApi.get(`${BASE}/me`),
  dashboard: () => partnerApi.get(`${BASE}/dashboard`),
  customers: (params) => partnerApi.get(`${BASE}/customers`, { params }),
  paymentHistory: (params) => partnerApi.get(`${BASE}/payment-history`, { params }),
  withdrawals: (params) => partnerApi.get(`${BASE}/withdrawals`, { params }),
  requestWithdrawal: (data) => partnerApi.post(`${BASE}/withdrawals`, data),
  getSettings: () => partnerApi.get(`${BASE}/settings`),
  updateSettings: (data) => partnerApi.put(`${BASE}/settings`, data),
  changePassword: (data) => partnerApi.put(`${BASE}/settings/password`, data),
};

export default partnerApi;
